import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { EmptyState } from "../components/EmptyState.tsx";
import { api } from "../lib/api.ts";
import { useI18n } from "../lib/i18n.tsx";
import { Markdown } from "../lib/markdown.tsx";

type Doc = { doc: string; version: string; published_at: number; md_vi: string; md_en: string };

/** /legal/terms | privacy | prohibited — versioned policy text (R-LEG-1). */
export function Legal() {
  const { doc = "terms" } = useParams();
  const { t, locale } = useI18n();
  const [state, setState] = useState<
    { status: "loading" } | { status: "missing" } | { status: "ok"; d: Doc }
  >({ status: "loading" });

  useEffect(() => {
    let live = true;
    api<Doc>(`/api/policy/${encodeURIComponent(doc)}`)
      .then((d) => live && setState({ status: "ok", d }))
      .catch(() => live && setState({ status: "missing" }));
    return () => {
      live = false;
    };
  }, [doc]);

  if (state.status === "loading") return <div className="page muted">{t("common.loading")}</div>;
  if (state.status === "missing")
    return (
      <div className="page">
        <EmptyState icon="?" text={t("error.not_found")} cta={{ label: t("nav.home"), to: "/" }} />
      </div>
    );
  const d = state.d;
  return (
    <div className="page page--narrow" data-testid="legal">
      <Markdown source={locale === "vi" ? d.md_vi : d.md_en} />
      <p className="hint">{t("legal.version", { version: d.version })}</p>
    </div>
  );
}
